<template>
    <div>
        <div v-if="isPostMethod">
            <button
                ref="launchActionHandlerButton"
                class="btn init-cart"
                type="button"
                :class="cssClasses"
                :disabled="disabled"
                :data-timer="dataTimer"
                :data-oevent-category="tmsDtoCategory"
                :data-oevent-action="tmsDtoAction"
                :data-oevent-label="tmsDtoLabel"
                @click="launchActionHandler($event)"
            >
                <span :class="{ 'd-lg-none': withDesktopButton }">{{ buttonLabel }}</span>
                <span v-if="withDesktopButton" class="d-none d-lg-inline-block">{{ desktopButtonLabel }}</span>
            </button>
        </div>

        <div v-else-if="isGetMethod">
            <a
                class="btn"
                :class="cssClasses + ((disabled)? ' disabled' : '')"
                :aria-disabled="disabled"
                :href="actionUrl"
                :data-oevent-category="tmsDtoCategory"
                :data-oevent-action="tmsDtoAction"
                :data-oevent-label="tmsDtoLabel"
            >
                <span :class="{ 'd-lg-none': withDesktopButton }">{{ buttonLabel }}</span>
                <span v-if="withDesktopButton" class="d-none d-lg-inline-block">{{ desktopButtonLabel }}</span>
            </a>
        </div>
    </div>
</template>

<script>
export default {
    name: "ProgressButtonCta",
    props: {
        buttonLabel: {
            type: String,
            required: true
        },
        desktopButtonLabel: {
            type: String,
            required: false,
            default: undefined
        },
        cssClasses: {
            type: String,
            required: false,
            default: "btn-primary"
        },
        actionHttpMethod: {
            type: String,
            required: false,
            default: "POST"
        },
        actionUrl: {
            type: String,
            required: true
        },
        actionFormParams: {
            type: Object,
            required: false,
            default() {
                return {};
            }
        },
        actionJsonFormParams: {
            type: Object,
            required: false,
            default() {
                return {};
            }
        },
        dataTimer: {
            type: String,
            required: true
        },
        tmsDto: {
            type: Object,
            required: true
        },
        emitEventOnActionErrors: {
            type: Boolean,
            required: false,
            default: false
        },
        redirectUrlOnActionFunctionalErrors: {
            type: String,
            required: false,
            default: undefined
        },
        redirectUrlOnActionTechnicalErrors: {
            type: String,
            required: false,
            default: undefined
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data: function () {
        return {
            hash: Math.floor(Math.random() * 0xffffffff).toString(16),
        }
    },
    computed: {
        isPostMethod() {
            return (this.actionHttpMethod === "POST");
        },
        isGetMethod() {
            return (this.actionHttpMethod === "GET");
        },
        isJsonForm() {
            return this.actionJsonFormParams && Object.keys(this.actionJsonFormParams).length > 0
        },
        withDesktopButton() {
            return (this.desktopButtonLabel) && (this.desktopButtonLabel !== "");
        },
        tmsDtoCategory() {
            return this.tmsDto.category;
        },
        tmsDtoAction() {
            return this.tmsDto.action;
        },
        tmsDtoLabel() {
            return this.tmsDto.label;
        },
        token() {
            return document.querySelector('[data-token]').getAttribute('data-token')
        }
    },
    methods: {
        launchActionHandler: function (event) {
            this.animProgress(event, this.$refs.launchActionHandlerButton);
            const actionErrorsHandler = this.actionErrorsHandler();
            if (this.isJsonForm) {
                const token = this.token;
                $.ajax({
                    method: "POST",
                    url: this.actionUrl,
                    contentType: "application/json",
                    beforeSend: function (xhr) {
                        xhr.setRequestHeader('token', token);
                    },
                    data: JSON.stringify(this.actionJsonFormParams)
                }).done((response) => {
                    const url = response.redirectUrl || response.data;
                    window.location.href = url;
                }).fail(actionErrorsHandler);
            } else {
                new MshRequest()
                    .post(this.actionUrl, this.actionFormParams)
                    .then((resp) => {
                        if (resp.success) {
                            document.location = resp.data || resp.redirectUrl;
                        }
                    })
                    .catch(actionErrorsHandler);
            }

            return false
        },
        animProgress: function (event, button) {
            // Vérification que ce button est présent et unique
            if (button && !Array.isArray(button)) {
                button.disabled = true;
                button.setAttribute("data-ob1-component", "ProgressBarDetermined");
                // Permet de rafraîchir le composant afin de lancer l'animation de la barre de progression
                ob1.Ob1Component.load(document.body);
            }
        },
        actionErrorsHandler: function () {
            return (error) => {
                if (this.emitEventOnActionErrors) {
                    this.$emit('action-error', error)
                } else {
                    if (this.redirectUrlOnActionFunctionalErrors && error && error.status && error.status >= 400 && error.status < 500) {
                        window.location.href = this.redirectUrlOnActionFunctionalErrors;
                    } else if (this.redirectUrlOnActionTechnicalErrors) {
                        window.location.href = this.redirectUrlOnActionTechnicalErrors;
                    } else {
                        // do nothing
                        // maybe reload page ?
                    }
                }
            }
        }
    }
}
</script>


<style scoped lang="scss">

</style>
